<template>
    <tr>
        <td colspan="7">{{ $t('staff.membersTab.newUserLabel') }}</td>
        <td>
            <div class="actions">
                <a
                    :title="$t('common.save')"
                    :class="['btn-edit', { disabled: saveDisabled }]"
                    @click.prevent="save"
                >
                    <i class="icon-checkmark"></i>
                </a>
                <a :title="$t('common.cancel')" class="btn-trash" @click.prevent="closeClick" @dblclick.stop>
                    <i class="icon-close"></i>
                </a>
            </div>
        </td>
    </tr>
</template>

<script type="text/babel">
import { mapState } from 'vuex';

export default {
    name: 'AddRowHeader',

    components: {},

    mixins: [],

    constants: {},

    props: {
        saveDisabled: {
            type: Boolean,
            default: false,
        },
        closeClick: {
            type: Function,
            required: true,
        },
        saveClick: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            isValid: false,
        };
    },

    computed: {
        ...mapState(['unsavedChanges']),
    },

    methods: {
        save() {
            if (!this.saveDisabled) {
                this.saveClick();
            }
        },
    },
};
</script>
